export default __webpack_public_path__ + "static/billboard-divider-b9eecab4ce4698dec81922a9587aee0a.png";